"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;

var _constants = require("./constants");

var _textStyle = require("../../themes/default/textStyle");

var _utils = require("./utils");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _StyledBaseText = _interopRequireDefault(require("./StyledBaseText"));

var _styles = require("./styles");

var _theming = require("../../theming");

var _constants2 = require("../../theming/typography/constants");

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// About StyledBaseText vs TextElementLegacy:
//
// The values for the legacy Typography system `styles` were collections
// of individual styling properties. Because the new system
// will be themeable and also have different properties based
// on theme density, window width, and any theme overrides for
// individual properties, Text.Styles[semantic name] for the new
// system will be string values of the semantic (similar to how
// Text.Colors works) so that the component can access theme
// values for the style properties.
// If the `styles` property is NOT a string, we can assume that it
// is a value in the legacy system, and we will render a BaseTextLegacy
// node accordingly.
var BaseText = function BaseText(_ref) {
  var mobileStyles = _ref.mobileStyles,
      tabletStyles = _ref.tabletStyles,
      desktopStyles = _ref.desktopStyles,
      wideScreenStyles = _ref.wideScreenStyles,
      props = _objectWithoutProperties(_ref, ["mobileStyles", "tabletStyles", "desktopStyles", "wideScreenStyles"]);

  if (typeof props.styles === 'string') {
    return /*#__PURE__*/_react["default"].createElement(_StyledBaseText["default"], _extends({
      mobileStyles: mobileStyles,
      tabletStyles: tabletStyles,
      desktopStyles: desktopStyles,
      wideScreenStyles: wideScreenStyles
    }, props));
  } // To Do (lindsey-menges): remove legacy system in v6


  var theme = _react["default"].useContext(_theming.ThemingContext);

  var themeDensityString = "".concat((0, _lodash["default"])(theme, "Typography.Density", _constants2.TypographyDensities.Regular), "Density");
  var colorProp = props.color || props.styles.color;
  colorProp = theme.Colors[colorProp] || BaseText.Colors[colorProp];
  var themeDecorationColor = theme.Colors[props.textDecorationColor] || BaseText.Colors[props.textDecorationColor];
  var themeFontFamily = theme.Typography.FontFamily;

  if (typeof mobileStyles === 'string') {
    mobileStyles = (0, _utils.getThemeTextStyleValues)({
      completeSemanticDefinition: theme.Typography.TextStyles[mobileStyles],
      themeDensityString: themeDensityString,
      "default": BaseText.defaultProps.styles
    });
  }

  if (typeof tabletStyles === 'string') {
    tabletStyles = (0, _utils.getThemeTextStyleValues)({
      completeSemanticDefinition: theme.Typography.TextStyles[tabletStyles],
      themeDensityString: themeDensityString,
      "default": BaseText.defaultProps.styles,
      includeDesktopOverrides: true
    });
  }

  if (typeof desktopStyles === 'string') {
    desktopStyles = (0, _utils.getThemeTextStyleValues)({
      completeSemanticDefinition: theme.Typography.TextStyles[desktopStyles],
      themeDensityString: themeDensityString,
      "default": BaseText.defaultProps.styles,
      includeDesktopOverrides: true
    });
  }

  if (typeof wideScreenStyles === 'string') {
    wideScreenStyles = (0, _utils.getThemeTextStyleValues)({
      completeSemanticDefinition: theme.Typography.TextStyles[wideScreenStyles],
      themeDensityString: themeDensityString,
      "default": BaseText.defaultProps.styles,
      includeDesktopOverrides: true
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_styles.TextElement, _extends({
    themeFontFamily: themeFontFamily,
    textColor: colorProp,
    themeDecorationColor: themeDecorationColor,
    mobileStyles: mobileStyles,
    tabletStyles: tabletStyles,
    desktopStyles: desktopStyles,
    wideScreenStyles: wideScreenStyles
  }, props));
};

BaseText.DisplayModes = _constants.DisplayModes;
BaseText.Sizes = _constants.Sizes;
BaseText.Styles = _objectSpread(_objectSpread(_objectSpread({}, _textStyle.LegacyTokens), _textStyle.LegacySemantics), (0, _utils.getStylesOptions)());
BaseText.Weights = _constants.TextWeights;
BaseText.Families = _constants.FontFamilies;
BaseText.LineHeights = _constants.LineHeights;
BaseText.LetterSpacings = _constants.LetterSpacings;
BaseText.TextTransforms = _constants.TextTransforms;
BaseText.TextAlignments = _constants.TextAlignments;
BaseText.TextDecorations = _constants.TextDecorations;
BaseText.Overflows = _constants.Overflows;
BaseText.Colors = _utils.TextColors;

var SizeProp = _propTypes["default"].oneOf(Object.values(_constants.Sizes));

var FamilyProp = _propTypes["default"].oneOf(Object.values(_constants.FontFamilies));

var WeightProp = _propTypes["default"].oneOf(Object.values(BaseText.Weights));

var LineHeightProp = _propTypes["default"].oneOf(Object.values(_constants.LineHeights));

var LetterSpacingProp = _propTypes["default"].oneOf(Object.values(_constants.LetterSpacings));

var TextTransformProp = _propTypes["default"].oneOf(Object.values(_constants.TextTransforms));

var TextDecorationProp = _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].oneOf(Object.values(_constants.TextDecorations))), _propTypes["default"].oneOf(Object.values(_constants.TextDecorations))]);

var TextDecorationColorProp = _propTypes["default"].oneOf(Object.values(BaseText.Colors));

var ColorProp = _propTypes["default"].oneOf(Object.values(BaseText.Colors));

var TextAlignProp = _propTypes["default"].oneOf(Object.values(_constants.TextAlignments));

var OverflowProp = _propTypes["default"].oneOf(Object.values(_constants.Overflows));

var ThemeFontFamilyProp = _propTypes["default"].string;

var StylesProp = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
  themeFontFamily: ThemeFontFamilyProp,
  size: SizeProp,
  family: FamilyProp,
  weight: WeightProp,
  lineHeight: LineHeightProp,
  letterSpacing: LetterSpacingProp,
  textTransform: TextTransformProp,
  color: ColorProp
})]);

BaseText.propTypes = {
  size: SizeProp,
  family: FamilyProp,
  weight: WeightProp,
  lineHeight: LineHeightProp,
  letterSpacing: LetterSpacingProp,
  textTransform: TextTransformProp,
  textAlign: TextAlignProp,
  textDecoration: TextDecorationProp,
  textDecorationColor: TextDecorationColorProp,
  overflow: OverflowProp,
  color: ColorProp,
  styles: StylesProp,
  wideScreenStyles: StylesProp,
  desktopStyles: StylesProp,
  tabletStyles: StylesProp,
  mobileStyles: StylesProp,
  maxLines: _propTypes["default"].number,
  display: _propTypes["default"].oneOf(Object.values(_constants.DisplayModes))
};
BaseText.defaultProps = {
  display: _constants.DisplayModes.Block,
  styles: BaseText.Styles.Medium16
};
var Text = BaseText;
exports.Text = Text;
Text.propTypes = BaseText.propTypes;
Text.defaultProps = BaseText.defaultProps;
Text.DisplayModes = BaseText.DisplayModes;
Text.Sizes = BaseText.Sizes;
Text.Styles = BaseText.Styles;
Text.Weights = BaseText.Weights;
Text.Families = BaseText.Families;
Text.LineHeights = BaseText.LineHeights;
Text.LetterSpacings = BaseText.LetterSpacings;
Text.TextTransforms = BaseText.TextTransforms;
Text.TextAlignments = BaseText.TextAlignments;
Text.TextDecorations = BaseText.TextDecorations;
Text.Overflows = BaseText.Overflows;
Text.Colors = BaseText.Colors;